import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { saveExportFailed, saveExportSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';

export default function* saveExport(action) {
  try {
    const url = `${BACKEND_URL}/api/v1/uploader/add`;
    const dataResponse = yield makeRequest(url, action.payload, action, 'POST', true);
    const data = yield dataResponse.json();
    if (dataResponse.status === OK) {
      yield put(saveExportSuccessful(data));
      yield call(resolveActionPromise(action, data));
    } else {
      yield put(saveExportFailed());
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(saveExportFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
